import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../../../app.service';
import { Observable } from 'rxjs';

export interface OrderStatus {
    phoneNumber: string;
    mmState: string;
    mmStateDetail: string;
    currentScState: string;

    initialScOrderState: any;
    mmOrderState: any;
    currentScOrderState: any;

    sharedBondLine: any;
    sharedBond: any;
    mmSharedBondOrderState: any;
}

@Injectable({
    providedIn: 'root'
})
export class MobileService {

    appData: any;

    constructor(
        private httpClient: HttpClient,
        private appService: AppService,
    ) {
        this.appData = appService.settings;
    }

    getOrderStatus(externalId: string): Observable<OrderStatus> {
        return this.httpClient.get<OrderStatus>(`${this.appData.webApi}/mobile/v1/requests/orderState/${externalId}`);
    }

}